import { render, staticRenderFns } from "./ServiceProviderItem.vue?vue&type=template&id=7988fb8b&"
import script from "./ServiceProviderItem.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports